// Sessiya ma'lumoti localStorage'da.
//
// NEGA localStorage, httpOnly cookie EMAS: panel backend bilan boshqa
// origin'da (subdomen) ishlashi mumkin, cookie esa u holda SameSite
// sozlamalarini talab qiladi va deploy'ni murakkablashtiradi. XSS xavfi bor,
// lekin u `httpOnly` cookie bilan ham token o'g'irlamasdan so'rov yuborish
// orqali saqlanib qoladi — asosiy himoya baribir backendda (04-ROLES.md §5).

const TOKEN_KEY = 'xsib.token'
const EXPIRES_KEY = 'xsib.expiresAt'
const REFRESH_KEY = 'xsib.refreshToken'

function read(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // localStorage yopiq bo'lsa sessiya faqat shu yorliqda yashaydi —
    // bu panelni to'xtatish uchun yetarli sabab emas
  }
}

function remove(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // e'tiborsiz
  }
}

export function getToken(): string | null {
  return read(TOKEN_KEY)
}

export function getExpiresAt(): string | null {
  return read(EXPIRES_KEY)
}

/**
 * Refresh token — 14 kunlik, access token esa 30 daqiqalik.
 *
 * ⚠️ Bu qiymat AYLANADI: har muvaffaqiyatli `POST /api/auth/refresh`
 * yangisini qaytaradi va eskisini o'sha zahoti sarflaydi. Eskisi qayta
 * yuborilsa server buni REPLAY (o'g'irlangan token belgisi) deb biladi va
 * foydalanuvchining BARCHA tokenlarini bekor qiladi — ya'ni noto'g'ri
 * saqlash hech narsa qilmaslikdan ham battar. Jonli tizimda tekshirilgan:
 * eski qiymat bilan bitta so'rov yetarli, undan keyin YANGI (to'g'ri) token
 * ham 401 qaytara boshlaydi.
 *
 * Shuning uchun yagona yozish nuqtasi — quyidagi `saveSession`.
 */
export function getRefreshToken(): string | null {
  return read(REFRESH_KEY)
}

/**
 * Sessiyani saqlaydi — kirish, tashkilot almashtirish va tokenni
 * yangilash uchun YAGONA yo'l.
 *
 * ⚠️ Berilmagan maydon O'CHIRILADI (saqlanib qolmaydi):
 *   · `expiresAt` — qolib ketsa yangi sessiya eski (allaqachon o'tgan)
 *     muddat bilan darhol "tugagan" deb hisoblanardi
 *   · `refreshToken` — qolib ketsa u ALLAQACHON SARFLANGAN qiymat
 *     bo'lardi va keyingi yangilash urinishi REPLAY ga aylanardi
 *     (yuqoridagi izoh). "Refresh token yo'q" holati shunchaki 30
 *     daqiqadan keyin qayta kirishni bildiradi — bu esa butun sessiyalar
 *     oilasi bekor qilinishidan ancha yengil.
 */
export function saveSession(
  token: string,
  expiresAt?: string | null,
  refreshToken?: string | null,
): void {
  write(TOKEN_KEY, token)
  if (expiresAt) write(EXPIRES_KEY, expiresAt)
  else remove(EXPIRES_KEY)
  if (refreshToken) write(REFRESH_KEY, refreshToken)
  else remove(REFRESH_KEY)
}

export function clearSession(): void {
  remove(TOKEN_KEY)
  remove(EXPIRES_KEY)
  remove(REFRESH_KEY)
}

/**
 * Token muddati o'tganmi.
 *
 * ⚠️ Token YO'Q bo'lsa `false` qaytaradi — "muddati o'tgan" va "umuman yo'q"
 * boshqa-boshqa holatlar. Chaqiruvchi (`client.ts`) ikkalasini alohida
 * tekshiradi, chunki tizimdan chiqarish qarori aynan shu ikkisiga tayanadi.
 *
 * Access token 30 daqiqada tugaydi, ya'ni bu tekshiruv nazariy emas: operator
 * ish kunida bir necha marta uchratadi. ⚠️ Endi u O'ZI chiqarib yubormaydi —
 * `sessionRefresh.ts` refresh tokeni bilan yangilashga urinadi; bu tekshiruv
 * esa "401 sababi aynan muddat" degan SIGNAL bo'lib xizmat qiladi
 * (`client.ts` dagi izoh).
 */
export function isTokenExpired(): boolean {
  const expiresAt = getExpiresAt()
  if (!expiresAt) return false
  const ts = Date.parse(expiresAt)
  return !Number.isNaN(ts) && ts <= Date.now()
}

/**
 * Sessiyani DAVOM ETTIRISH mumkinmi — sahifa yangilanganda birinchi
 * savol shu.
 *
 * ⚠️ MUDDATI O'TGAN ACCESS TOKEN ENDI "SESSIYA TUGADI" DEGANI EMAS.
 * Ilgari bu funksiya shunday deb hisoblardi va sessiyani darhol
 * tozalardi. Oqibati: operator noutbukni yopib, bir soatdan keyin
 * sahifani yangilasa — refresh tokeni hali 14 kun amal qilishiga
 * qaramay kirish sahifasiga tushardi. Ya'ni foydalanuvchi shikoyat
 * qilgan "har 30 daqiqada chiqarib yuboradi" muammosining yarmi aynan
 * shu yerda edi, 401 ishlovida emas.
 *
 * Endi refresh tokeni bo'lsa `true` qaytadi: birinchi so'rov 401 oladi,
 * `client.ts` interceptor'i tokenni yangilaydi va so'rovni takrorlaydi.
 */
export function hasValidToken(): boolean {
  if (!getToken()) return false
  if (isTokenExpired()) {
    if (getRefreshToken()) return true
    clearSession()
    return false
  }
  return true
}
